var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn_tag mr-1",class:{ 'tag1': _vm.borderColor === 'yellow',
               'tag2': _vm.borderColor === 'green',
               'tag3': _vm.borderColor === 'blue',
               'tag4': _vm.borderColor === 'green1',
               'tag5': _vm.borderColor === 'blue1', }},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }